import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';

import { TranslateService } from 'ng2-translate';
import { IProject } from '../../model/top.model';
import { ProjectData } from '../../providers/project-data';

@Component({
  selector: 'page-select-project',
  templateUrl: 'select-project.html'
})
export class SelectProjectModal {
  private filterName: string;
  private projects: Array<IProject>;
  private selectedProject: IProject;

  constructor(public navCtrl: NavController, public navParams: NavParams, private viewCtrl: ViewController, private projectData: ProjectData, private translate: TranslateService) {
    this.projects = [];
    this.filterName = "";
  }

  ionViewWillEnter() {
    this.projectData.getProjects().then((result: Array<IProject>) => {
      this.projects = result;
    });
  }

  projectTapped($event, project) {
    this.selectedProject = project;
  }

  filterProjects() {
    this.projects = this.projectData.filterProjects(this.filterName);
  }

  dismiss() {
    this.selectedProject.timeRegistrations = [];
    this.viewCtrl.dismiss(this.selectedProject);
  }

  cancel() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/modals/select-project/select-project.ts